module.exports = __webpack_public_path__ + "img/peak.614e5484.jpg";